<scitis-app-global-page-header [pageTitle]="'Details'">
</scitis-app-global-page-header>


<div class="card mb-3">
  <div class="card-body">

    <!--DETAILS-->
    <div class="row">

      <!--COLUMN 1-->
      <div class="col-12 col-md-6 col-lg-3">

        <!--SERIAL-->
        <div class="mb-3">
          <strong class="h5 d-block" translate>Serial number</strong>
          <p [innerText]="gateway.id"></p>
        </div>

        <!--NAME-->
        <div class="mb-3">
          <strong class="h5 d-block" translate>Name</strong>
          <p [innerText]="gateway.name"></p>
        </div>

        <!--NAME-->
        <div class="mb-3">
          <strong class="h5 d-block" translate>External id</strong>
          <p [innerText]="gateway.externalId"></p>
        </div>

        <!--STREAMED DATA ROW-->
        @if (gateway.streamingRowSizes && gateway.streamingRowSizes['OPC']) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>Streamed data row</strong>
            <span
              [ngClass]="{'status-success':(gateway.streamingRowSizes['OPC'] > 0 && gateway.streamingRowSizes['OPC'] < 1), 'status-danger': (gateway.streamingRowSizes['OPC'] >= 1 || gateway.streamingRowSizes['OPC'] === -1) }"
              class="status status-success">
            </span>
            <span
              [ngClass]="{'text-success':(gateway.streamingRowSizes['OPC'] > 0 && gateway.streamingRowSizes['OPC'] < 1),'text-danger': gateway.streamingRowSizes['OPC'] >= 1 || gateway.streamingRowSizes['OPC'] === -1}">
              @if (gateway.streamingRowSizes['OPC'] === -1) {
                <span>N/A</span>
              }
              @if (gateway.streamingRowSizes['OPC'] !== -1) {
                <span
                [innerText]="gateway.streamingRowSizes['OPC'] * 1024+' KB'"></span>
              }
            </span>
          </div>
        }

      </div>

      <!--COLUMN 2-->
      <div class="col-12 col-md-6 col-lg-3">

        <!--TYPE-->
        <div class="mb-3">
          <strong class="h5 d-block" translate>Gateway type</strong>
          @if (gateway.cloudplugType) {
            <p [innerText]="gateway.cloudplugType|translate"></p>
          }
        </div>

        <!--STREAMING TYPE-->
        @if (isCPOneGateway || isCPEdgeGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>Streaming Type</strong>
            @if (isIotBridgeStreaming()) {
              <p translate>IoT Bridge</p>
            }
            @if (!isIotBridgeStreaming()) {
              <p translate>Scitis Bridge</p>
            }
          </div>
        }

        <!--BIGQUERY DATASET-->
        <div class="mb-3">
          <strong class="h5 d-block" translate>BigQuery dataset</strong>
          <p [innerText]="gateway.bqDataset" class="break-word"></p>
        </div>

      </div>

      <!--COLUMN 3-->
      <div class="col-12 col-md-6 col-lg-3">

        <!--IOT CORE REGISTRY-->
        @if (shouldDisplayIotCoreDetails()) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>IOT Core Registry</strong>
            <p [innerText]="gateway.iotCore.registryId"></p>
          </div>
        }


        <!--LAST UPDATE-->
        @if (isCPEdgeGateway || isCPOneGateway || isCPSoftGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>Last update</strong>
            <p [innerText]="getLastUpdateStatus(gateway.updateStatus)"></p>
          </div>
        }

        <!--STATE-->
        @if (isCPEdgeGateway || isCPOneGateway || isCPSoftGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>State</strong>
            <p><span [innerText]="getUpdateStatus(gateway.updateStatus)"></span></p>
          </div>
        }

      </div>

      <!--COLUMN 4-->
      <div class="col-12 col-md-6 col-lg-3">

        <!--LAST CONTACT-->
        @if (isCPLightGateway || isGenericGateway || isArgosGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>Last contact</strong>
            <p [innerText]="getLastConnectionStatus(gateway.connectionStatus)"></p>
          </div>
        }

        <!--STATE-->
        @if (isCPLightGateway || isGenericGateway || isArgosGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>Status</strong>
            <p [innerText]="getConnectionStatus(gateway.connectionStatus)"></p>
          </div>
        }

        <!-- LAST REBOOT -->
        @if (isCPEdgeGateway || isCPOneGateway || isCPSoftGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>Last reboot</strong>
            <p [innerText]="getLastRebootStatus(gateway.rebootStatus)"></p>
          </div>
        }

        <!--REBOOT STATE-->
        @if (isCPEdgeGateway || isCPOneGateway || isCPSoftGateway) {
          <div class="mb-3">
            <strong class="h5 d-block" translate>State</strong>
            <p><span [innerText]="getRebootStatus(gateway.rebootStatus)"></span></p>
          </div>
        }

      </div>

    </div>

    <div class="divider"></div>

    <!--PACKAGES-->
    @if (isCPOneGateway) {
      <div class="row">
        <div class="col-12">
          <div class="section-head mb-3">
            <h4 translate>Installed packages</h4>
            <div class="input-group mb-2">
              <div class="form-check">
                <input (change)="changeStatus($event)" [checked]="updatePackage" class="form-check-input"
                  id="checkUpdatePackage"
                  type="checkbox">
                  <label class="form-check-label" for="checkUpdatePackage" translate>
                    Show only packages with update available
                  </label>
                </div>
              </div>
              <div class="search">
                <input (input)="onSearchPackages($event)" [placeholder]="'Search package ...'|translate"
                  class="form-control"
                  type="search">
                </div>
              </div>
              <div class="table-responsive-md">
                <table class="table vertical-align-middle mb-0">
                  <thead>
                    <tr>
                      <th translate>Package</th>
                      <th translate>Revision</th>
                      <th translate>Candidate</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (softPackage of filteredPackages; track softPackage) {
                      <tr>
                        <td>
                          <b>
                    <span [ngClass]="{
                    'status-success': softPackage.revision === softPackage.candidate,
                    'status-danger': softPackage.revision !== softPackage.candidate
                    }" class="status ">
                            </span>
                            <ngb-highlight [result]="softPackage.name" [term]="searchTerm"></ngb-highlight>
                          </b>
                        </td>
                        <td>
                          <ngb-highlight [result]="softPackage.revision" [term]="''"></ngb-highlight>
                        </td>
                        <td>
                          <ngb-highlight [result]="softPackage.candidate" [term]="''"></ngb-highlight>
                        </td>
                      </tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="3">
                        <span class="d-inline-block mr-2">
                          <span class="status status-success"></span>
                          <span translate>Installation status ok</span>
                        </span>
                        <span class="d-inline-block mr-2">
                          <span class="status status-danger"></span>
                          <span translate>Installation status not ok</span>
                        </span>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        }

      </div>
    </div>
